export const RAW_DATA_VIDEO_PLAYER_OPEN_MODAL = "RAW_DATA_VIDEO_PLAYER_OPEN_MODAL";
export const RAW_DATA_VIDEO_PLAYER_CLOSE_MODAL = "RAW_DATA_VIDEO_PLAYER_CLOSE_MODAL";
export const RAW_DATA_VIDEO_PLAYER_REFRESH_URLS_REQUEST = "RAW_DATA_VIDEO_PLAYER_REFRESH_URLS_REQUEST";
export const RAW_DATA_VIDEO_PLAYER_REFRESH_URLS_ERROR = "RAW_DATA_VIDEO_PLAYER_REFRESH_URLS_ERROR";
